const getEstimateRecreationState = ({
  invoices = [],
  lineItems = [],
  totalAmount = 0,
}) => {
  const existingEstimate = invoices.find(
    (invoice) => invoice.invoice_type === "EST"
  );
  if (!existingEstimate) {
    return null;
  }

  const invoiceLineItemIds = new Set(
    (existingEstimate.line_items || []).map(String)
  );
  const amountDue = Number(existingEstimate.amount_due || 0);

  return {
    selectedLineItems: lineItems.filter((item) =>
      invoiceLineItemIds.has(String(item.id))
    ),
    percentage:
      totalAmount > 0 ? ((amountDue / totalAmount) * 100).toFixed(2) : "",
    amountDue: amountDue.toFixed(2),
  };
};

export { getEstimateRecreationState };
